export const categorizeByExistence = (entities, allExistingEntitiesMap) => {
  const [newEntities, existingEntities] = entities.reduce((_ref, entity) => {
    let [newMap, existingMap] = _ref;
    if (allExistingEntitiesMap && entity.name) {
      const existingEntity = allExistingEntitiesMap[entity.name];
      if (existingEntity) {
        existingMap.push(existingEntity);
      } else {
        newMap.push(entity);
      }
    } else {
      if (entity.id) {
        existingMap.push(entity);
      } else {
        newMap.push(entity);
      }
    }
    return [newMap, existingMap];
  }, [[], []]);
  return {
    newEntities,
    existingEntities
  };
};
export const filterOutDuplicatedNames = entities => {
  return entities.filter((entityOne, index) => entities.findIndex(entityTwo => entityOne.name === entityTwo.name) === index);
};
//# sourceMappingURL=common.js.map